module.exports = __webpack_public_path__ + "img/UTPIUT-2.a74972bb.jpg";